import type { CheckoutConfig } from '#types/config/pages/checkout'
import type { RecursivePartial } from '#types/utils'

export default {
  brandClasses: {
    legalCheckbox: 'text-xs  mt-4'
  },
  contactFieldsOrder: (() => ['phone', 'email']) as unknown as CheckoutConfig['contactFieldsOrder'],
  hideLoyaltyDivider: true,
  loyaltyType: [
    'REWARD_CARD',
    'REWARD_CODE',
  ]
} satisfies RecursivePartial<CheckoutConfig>
